import { Clipboard } from '@capacitor/clipboard';
import {
	RiFacebookFill,
	RiInstagramLine,
	RiLinkedinFill,
	RiThreadsLine,
	RiTiktokLine,
	RiTwitterXFill,
	RiWhatsappLine,
} from '@remixicon/react';
import { toast } from 'sonner';
import { Balance } from '../components/Icons/Balance';
import { Basketball } from '../components/Icons/Basketball';
import { Dump } from '../components/Icons/Dump';
import { Football } from '../components/Icons/Football';
import { FutProIcon } from '../components/Icons/FutProIcon';
import { PadLock2 } from '../components/Icons/PadLock2';
import { PickProIcon } from '../components/Icons/PickProIcon';
import { Soccer } from '../components/Icons/Soccer';
import Toast from '../components/ui/toast';
import {
	choosePlatform,
	CurrencyFormatterNonDecimal,
	showWalletAndBalance,
} from './utils';

export const copyToClipboard = async (data: any) => {
	try {
		await Clipboard.write({ string: data });
		toast(<Toast variant="success">Copiado com sucesso!</Toast>);
	} catch (err) {
		console.log('Falha ao copiar o texto', err);
		toast(<Toast variant="error">Falha ao copiar.</Toast>);
	}
};

export const shared = [
	{
		title: 'Whatsapp',
		icon: <RiWhatsappLine className="text-[#4b4b4b]" />,
	},
	{
		title: 'Instagram',
		icon: <RiInstagramLine className="text-[#4b4b4b]" />,
	},
	{
		title: 'TikTok',
		icon: <RiTiktokLine className="text-[#4b4b4b]" />,
	},
	{
		title: 'X',
		icon: <RiTwitterXFill className="text-[#4b4b4b]" />,
	},
	{
		title: 'Threads',
		icon: <RiThreadsLine className="text-[#4b4b4b]" />,
	},
	{
		title: 'Facebook',
		icon: <RiFacebookFill className="text-[#4b4b4b]" />,
	},
	{
		title: 'Linkedin',
		icon: <RiLinkedinFill className="text-[#4b4b4b]" />,
	},
];

export const showIcon = (icon: string) => {
	switch (icon) {
		case 'limits':
			return <Balance />;
		case 'lock':
			return <PadLock2 />;
		case 'close':
			return <Dump />;
		default:
			return null;
	}
};

export const showInfoPrizeAndPrizeAmtBonus = (
	prizeAmt: number,
	prizeAmtBonus: number
) => {
	if (prizeAmt !== 0 && prizeAmtBonus === 0) {
		return (
			<div className="text-black max-[360px]:text-sm text-base font-light font-bahnschrift break-words w-full flex items-center gap-1">
				Participe e concorra a{' '}
				{showWalletAndBalance() ? (
					'R$ '
				) : choosePlatform() ? (
					<PickProIcon style="w-4 h-4" color="#000000" />
				) : (
					<FutProIcon style="w-4 h-4" color="#000000" />
				)}
				{CurrencyFormatterNonDecimal(Number(prizeAmt))} em prêmios!
			</div>
		);
	}
	if (prizeAmt === 0 && prizeAmtBonus !== 0) {
		return (
			<div className="text-black max-[360px]:text-sm text-base font-light font-bahnschrift break-words w-full flex items-center gap-1">
				Participe e concorra a B${' '}
				{CurrencyFormatterNonDecimal(Number(prizeAmtBonus))} em prêmios
				em bônus!
			</div>
		);
	}
	if (prizeAmt !== 0 && prizeAmtBonus !== 0) {
		return (
			<div className="text-black max-[360px]:text-sm text-base font-light font-bahnschrift break-words w-full flex items-center gap-1">
				Participe e concorra a{' '}
				{showWalletAndBalance() ? (
					'R$ '
				) : choosePlatform() ? (
					<PickProIcon style="w-4 h-4" color="#000000" />
				) : (
					<FutProIcon style="w-4 h-4" color="#000000" />
				)}
				{CurrencyFormatterNonDecimal(Number(prizeAmt))} + B${' '}
				{CurrencyFormatterNonDecimal(Number(prizeAmtBonus))} em prêmios!
			</div>
		);
	}

	return <></>;
};

export const iconModality = (name: string) => {
	let clearName = name.replace(/^@/, '');

	switch (clearName) {
		case 'Futebol':
			return <Soccer style="w-7" />;
		case 'Futebol Americano':
			return <Football style="w-7" />;
		case 'Basquete':
			return <Basketball style="w-7" />;
		default:
			return clearName.slice(0, 3).toUpperCase();
	}
};

export const shortNameModality = (name: string) => {
	let clearName = name.replace(/^@/, '');

	switch (clearName) {
		case 'Futebol Americano':
			return 'Fut. Ame.';

		default:
			return clearName;
	}
};
